/** FO receipt types — Vite aliases `packages/shared/dist/receipt/*.js` → shared TS source. */
export const RECEIPT_PRINTER_NOT_CONFIGURED = 'RECEIPT_PRINTER_NOT_CONFIGURED';

export type {
  ThermalReceiptData,
  ThermalReceiptLine,
  ReceiptPrinterConfig,
  ReceiptPaperSize,
  CupsPrinterInfo,
} from '@incashflow/shared/receipt/thermalReceiptTypes';

export {
  DEFAULT_RECEIPT_PAPER_SIZE,
  RECEIPT_PAPER_SIZES,
  isReceiptPaperSize,
  formatThermalReceiptDate,
} from '@incashflow/shared/receipt/thermalReceiptTypes';
